export default "__VITE_ASSET__De83Vx2h__"